export const msalConfig = {
  auth: {
    clientId: (window as any).location.href.includes('prod')
              ?
              'XXXX'
              :
              '6e7ec0e6-d860-4d25-952c-5d7b040d696f',
    authority: "https://login.microsoftonline.com/15ccb6d1-d335-4996-b6f9-7b6925f08121", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    redirectUri: (window as any).Config.RedirectUri,
    scope: []
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: []
};